import React, {
  useEffect,
  useRef
}                            from 'react';
import useGettimelineForPane from "../../../hooks/useGettimelineForPane";

import TimelineTitleComponent from "../TimelineTitleComponent";
import TimelineZoomComponent  from "../TimelineZoomComponent";
import './style.css';

import {
  renderTimeLine,
  TimelineOptionsType
} from "./utils";

const {CONFIG} = window;


interface Props {
  timeOptions: TimelineOptionsType,
  onMouseDown: (e: React.MouseEvent) => void,
  onMouseMove: (e: React.MouseEvent, ref: React.RefObject<HTMLCanvasElement>) => void,
  onMouseUp: (e: React.MouseEvent, ref: React.RefObject<HTMLCanvasElement>) => void,
  onWheel: (e: React.MouseEvent) => void,
  camID: string | null,
  playbackCams: any[],
  checkedPane: number | null,
  expandedVideoLayout: boolean,
  exportBounds?: { low: number, high: number } | null,
  width: number,
  isLocalTime: boolean
}

const TimelineComponent: React.FC<Props> = (
  {
    timeOptions,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onWheel,
    camID,
    playbackCams,
    checkedPane,
    expandedVideoLayout,
    exportBounds,
    width,
    isLocalTime
  }) => {
  const ref = useRef<HTMLCanvasElement>(null);
  const {time} = timeOptions;
  const style = {
    height: CONFIG.timeline.height + 'vh'
  };

  useEffect(() => {
    renderTimeLine(ref.current, timeOptions, camID, playbackCams, checkedPane, expandedVideoLayout, isLocalTime, exportBounds);
  }, [time, checkedPane, width, expandedVideoLayout, exportBounds, playbackCams]);

  useGettimelineForPane(time);

  return (
    <div className='pos-rel'>
      <div className='timeline'
           style={style}
      >
        <canvas id='ruler'
                ref={ref}
                width={width}
                height='100px'
                onMouseDown={onMouseDown}
                onMouseMove={(e) => onMouseMove(e, ref)}
                onMouseUp={(e) => onMouseUp(e, ref)}
                onMouseLeave={(e) => onMouseUp(e, ref)}
                onWheel={(e) => onWheel(e)}
        />
      </div>
      <TimelineZoomComponent/>
      <TimelineTitleComponent/>
    </div>
  )
};

export default TimelineComponent;